import LoupeIcon from "@/assets/images/icons2/icon--loupe.svg?component";
import { TextField2 } from "@/ui2/molecules/TextField";

type SearchFilterProps = {
  onChange: (value: string) => void;
  value: string;
};

export function SearchFilter({ onChange, value }: SearchFilterProps) {
  return (
    <TextField2
      icon={<LoupeIcon className="tw:text-fill-secondary" />}
      label="Search"
      mode="input"
      placeholder="Search notes, providers..."
      textInputProps={{
        onChange: (e) => onChange(e.target.value),
      }}
      value={value}
    />
  );
}
